var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 32,
    cy: 32,
    r: 32,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 33.5C26.75 30.6406 29.0938 28.25 32 28.25C34.8594 28.25 37.25 30.6406 37.25 33.5C37.25 36.4062 34.8594 38.75 32 38.75C29.0938 38.75 26.75 36.4062 26.75 33.5ZM32 30.5C30.3125 30.5 29 31.8594 29 33.5C29 35.1875 30.3125 36.5 32 36.5C33.6406 36.5 35 35.1875 35 33.5C35 31.8594 33.6406 30.5 32 30.5ZM36.9688 23.0469L37.4844 24.5H41C42.6406 24.5 44 25.8594 44 27.5V39.5C44 41.1875 42.6406 42.5 41 42.5H23C21.3125 42.5 20 41.1875 20 39.5V27.5C20 25.8594 21.3125 24.5 23 24.5H26.4688L26.9844 23.0469C27.2656 22.1562 28.1094 21.5 29.0938 21.5H34.8594C35.8438 21.5 36.6875 22.1562 36.9688 23.0469ZM23 26.75C22.5781 26.75 22.25 27.125 22.25 27.5V39.5C22.25 39.9219 22.5781 40.25 23 40.25H41C41.375 40.25 41.75 39.9219 41.75 39.5V27.5C41.75 27.125 41.375 26.75 41 26.75H35.8438L34.8594 23.75H29.0938L28.1094 26.75H23Z",
    fill: "#25272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMobileIcon);
export default __webpack_public_path__ + "static/media/cameraMobileIcon.38ec71268eee4219d4b0609243d855f0.svg";
export { ForwardRef as ReactComponent };